import { applicationActions } from "../reducer";

import { MenuItems } from "../../types";

export const setActiveMenuItem = (activeMenuItem: MenuItems) =>
  applicationActions.setActiveMenuItem(activeMenuItem);
